var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisabledIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0788 17.1509C14.1787 17.6901 13.1255 18 12 18C8.68629 18 6 15.3137 6 12C6 10.8137 6.34426 9.70787 6.93833 8.77688L15.0788 17.1509ZM16.6026 15.8493L8.28232 7.29024C9.30449 6.48229 10.5959 6 12 6C15.3137 6 18 8.68629 18 12C18 13.4651 17.4749 14.8075 16.6026 15.8493ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledIcn);
export default __webpack_public_path__ + "static/media/disabled-icn.3b9a88d8f8b400af38f1c37c0527f775.svg";
export { ForwardRef as ReactComponent };